import { useNavigate } from "react-router-dom";
import withRouter from "./withRouter";
import classNames from "classnames";
import { TNullable } from "../../common/types/common";

interface Props {
    disabled?: boolean;
    onClick?: TNullable<() => void>;
}

const BackLink = ({ onClick = null, disabled = false }: Props) => {
    const history = useNavigate();

    const handleOnClick = () => {
        if (disabled) return;

        if (onClick) {
            onClick();
        } else {
            history(-1);
        }
    };

    return (
        <span
            className={classNames('font-size-16 fw-medium', { 'text-primary': !disabled, 'text-muted': disabled})}
            style={{cursor: 'pointer'}}
            onClick={handleOnClick}
        >&lt; Back</span>
    );
};

export default withRouter(BackLink);
